var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-image',_vm._g(_vm._b({staticClass:"XwImg",attrs:{"src":_vm.src,"preview-src-list":[_vm.src]}},'el-image',_vm.$attrs,false),_vm.$listeners),[_c('template',{slot:"error"},[_vm._t("error",function(){return [_c('div')]})],2),_c('template',{slot:"placeholder"},[_vm._t("placeholder")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }